import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { FormGroup } from 'reactstrap';

interface ImageUploaderProps {
  value?: string;
  onChange: (url: string) => void;
  label?: string;
  size?: number;
}

const ImageUploader: React.FC<ImageUploaderProps> = ({
  value,
  onChange,
  label = 'Upload Image',
  size = 100,
}) => {
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      const file = acceptedFiles[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          onChange(reader.result);
        }
      };
      reader.readAsDataURL(file); // You can replace this with actual upload logic
    },
    [onChange],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      'image/*': [],
    },
  });

  return (
    <FormGroup className="text-center">
      <div {...getRootProps()} className="d-inline-block mb-3 cursor-pointer">
        <input {...getInputProps()} />
        <div
          style={{
            width: size,
            height: size,
            borderRadius: '50%',
            overflow: 'hidden',
            border: '2px dashed #ccc',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f8f9fa',
          }}
        >
          {value ? (
            <img
              src={value}
              alt="Preview"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          ) : (
            <span className="text-muted">{isDragActive ? 'Drop here' : label}</span>
          )}
        </div>
      </div>
    </FormGroup>
  );
};

export default ImageUploader;
